import React from 'react';
import { ForgotPasswordForm } from 'modules/components/layer12';
import { BasicFormModalLayout } from 'modules/components/layer13';

export type ForgotPasswordModalProps = {
  id: string;
  isVisible: boolean;
  handleClose: () => void;
};

export const FC = (props: ForgotPasswordModalProps) => {
  return (
    <BasicFormModalLayout.FC
      id=''
      title='Reset Password'
      subTitle='Enter your email to reset your password'
      handleClose={props.handleClose}
      isVisible={props.isVisible}
    >
      <ForgotPasswordForm.FC
        handleClose={props.handleClose}
      />
    </BasicFormModalLayout.FC>
  );
};
